import React, {useEffect, useState} from 'react';
import supabase from '../supabase/supabase';

const date = value => new Intl.DateTimeFormat('en-AU', {
  day:'numeric',month:'short',hour:'numeric',minute:'2-digit',timeZone:'Australia/Melbourne',
}).format(new Date(value));

export default function QuoteViewHistory({quoteId}) {
  const [activity, setActivity] = useState(null);
  const [error, setError] = useState(false);
  const [refresh, setRefresh] = useState(0);
  useEffect(() => {
    let active = true;
    setActivity(null);
    setError(false);
    if (!quoteId) return undefined;
    Promise.all([
      supabase.from('quote_views').select('id', {count:'exact',head:true}).eq('quote_id',quoteId),
      supabase.from('quote_views').select('viewed_at').eq('quote_id',quoteId).order('viewed_at',{ascending:true}).limit(1),
      supabase.from('quote_views').select('id,viewed_at,ip_address,city,region,country,notification_status')
        .eq('quote_id',quoteId).order('viewed_at',{ascending:false}).limit(10),
    ]).then(([count,first,recent]) => {
      if (!active) return;
      if (count.error || first.error || recent.error) { setError(true); return; }
      setActivity({count:count.count || 0,first:first.data?.[0]?.viewed_at,recent:recent.data || []});
    }).catch(() => {if (active) setError(true);});
    return () => {active = false;};
  }, [quoteId,refresh]);
  if (!quoteId) return null;
  return <section className="builder-section" style={{padding:18}}>
    <div style={{display:'flex',alignItems:'center',justifyContent:'space-between',gap:12}}>
      <h2 style={{fontSize:16,margin:0}}>Quote activity</h2>
      <button type="button" className="button button--outline" onClick={() => setRefresh(value => value+1)}>Refresh</button>
    </div>
    {error ? <p>View activity is temporarily unavailable.</p> : !activity ? <p>Loading activity…</p> : <>
      <p style={{marginTop:12}}><strong>{activity.count ? `Viewed ${activity.count} ${activity.count === 1 ? 'time' : 'times'}` : 'No views recorded yet'}</strong></p>
      {!!activity.count && <>
        <p style={{fontSize:12,color:'var(--muted)'}}>First: {date(activity.first)} · Last: {date(activity.recent[0].viewed_at)} · Melbourne time</p>
        <div style={{overflowX:'auto',marginTop:12}}><table style={{width:'100%',textAlign:'left',fontSize:12,borderCollapse:'collapse'}}>
          <thead><tr><th style={{padding:8}}>Opened</th><th style={{padding:8}}>Estimated location</th><th style={{padding:8}}>IP address</th><th style={{padding:8}}>Email</th></tr></thead>
          <tbody>{activity.recent.map(view => <tr key={view.id} style={{borderTop:'1px solid var(--line)'}}>
            <td style={{padding:8,whiteSpace:'nowrap'}}>{date(view.viewed_at)}</td>
            <td style={{padding:8}}>{[view.city,view.region,view.country].filter(Boolean).join(', ') || 'Unknown'}</td>
            <td style={{padding:8}}>{view.ip_address || 'Unavailable / expired'}</td>
            <td style={{padding:8}}>{{sent:'Sent',pending:'Sending',failed:'Failed',suppressed:'Cooldown / limit'}[view.notification_status]}</td>
          </tr>)}</tbody>
        </table></div>
      </>}
      <p style={{fontSize:12,color:'var(--muted)',marginTop:12}}>Tracking starts when this feature goes live. Signed-in previews are excluded. Locations are approximate and do not identify the viewer.</p>
    </>}
  </section>;
}
